<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> TECNOLOGIA </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="productTechnology.id"
          >{{ productTechnology.id }} -
          {{ productTechnology.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="productTechnology.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="productTechnology.description"
                class="text-field-uppercase"
                label="Descrição"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row v-if="productTechnology.icon">
            <v-col cols="12" xs="12" md="4">
              <v-img
                :lazy-src="getUrlPhoto(productTechnology.icon)"
                max-height="100"
                contain
                :src="getUrlPhoto(productTechnology.icon)"
              ></v-img>
            </v-col>
            <v-col cols="12" xs="12" md="8">
              <v-btn dark small text color="red darken-3" @click="deleteImage()"
                >Excluir Icone</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" xs="12" md="4">
              <v-file-input
                label="Icone"
                outlined
                dense
                required
                :error-messages="errorPhotoMessage"
                @change="onFilePicked"
                accept="image/*"
                prepend-icon="mdi-camera"
              ></v-file-input>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-switch
                v-model="productTechnology.status"
                :label="`Status: ${getLabelStatus(productTechnology.status)}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL_IMAGE } from "@/api/config";

import * as API from "@/api/requests/ProductTechnologyRequest";

export default {
  components: {},
  data: () => ({
    loading: false,
    icon: "",
    errorPhotoMessage: "",
    productTechnology: {
      id: "",
      name: "",
      description: "",
      status: 1,
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getProductTechnology(this.$route.params.id);
      }
    },
    async getProductTechnology(id) {
      // this.showLoading();
      this.loading = true;
      try {
        this.productTechnology = await API.getById(id);
      } catch (error) {
        this.productTechnology = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "ProductTechnology" });
    },
    onFilePicked(e) {
      this.icon = e;
      this.errorPhotoMessage = "";
    },
    validate() {
      if (this.$refs.form.validate()) {
        if (this.icon === "" && this.productTechnology.icon == "") {
          this.errorPhotoMessage = "Campo Obrigatorio";
          return false;
        }
        let form = new FormData();
        form.append("name", this.productTechnology.name.toUpperCase());
        form.append(
          "description",
          this.productTechnology.description.toUpperCase()
        );
        form.append("status", this.productTechnology.status ? 1 : 0);
        form.append(
          "icon",
          this.icon !== "" ? this.icon : this.productTechnology.icon
        );
        if (this.productTechnology.id === "") {
          this.post(form);
        } else {
          form.append("_method", "PUT");
          this.update(this.productTechnology.id, form);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    getUrlPhoto(icon) {
      if (icon !== "") {
        return `${URL_IMAGE}${icon}`;
      } else {
        return "";
      }
    },
    deleteImage() {
      this.icon = "";
      this.productTechnology.icon = "";
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
